import './../../Player.css';
import React, {useContext, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { PlayerContext } from '../../PlayerContext';
import { openFullscreen } from '../../Utils';
import { analyticsManager } from '../../../index';
import { useAnimate } from 'framer-motion';
import { useEffect } from 'react';
import { hasChainRestaurants } from '../../chainRestaurantUtils';
import { getStoredPixelConsent } from '../../PixelConsentOverlay';

function HoursButton(props){    

    const pauseVideo = useContext(PlayerContext).get("pauseVideo");
    const setActiveFeature = useContext(PlayerContext).get("setActiveFeature");
    const appAnalyticsManager = useContext(PlayerContext).get("appAnalyticsManager");
    const playMode = useContext(PlayerContext).get("playMode");
    const sizeMultiplier = useContext(PlayerContext).get("sizeMultiplier");
    const setPlayAudio = useContext(PlayerContext).get("setPlayAudio");
    const audioAlreadyDisabled = useContext(PlayerContext).get("audioAlreadyDisabled");
    const playAudio = useContext(PlayerContext).get("playAudio");
    const playerOnDesktop = useContext(PlayerContext).get("playerOnDesktop");
    const fromMaker = useContext(PlayerContext).get("fromMaker");
    const fromDemo = useContext(PlayerContext).get("fromDemo");
    const highlight = useContext(PlayerContext).get("highlight");
    const idPrefix = fromDemo ? (fromDemo +"-") : "";
    const [scope, animate] = useAnimate();

    // TODO Hours with no secondary hours

    const { t } = useTranslation();    

    useEffect(() => {
        if (highlight != null){

            let elementId = null;
            
            if (highlight.includes("hours") && !highlight.includes("restaurantInfos")){
                elementId = "btn-hours-v2";                
            }
        
            const element = document.getElementById(elementId);
            if (elementId != null && element != null){                  
                const animation = async () => {
                    await animate(element, { background: "#FFFFFFFF"}, {duration: 0.6});
                    if (element != null)
                        animate(element, { background: "#FFFFFF00"}, {duration: 0.6});
                }
                
                animation();
            }
        }
      }, [highlight, animate]);

    if (props.story.posId == null && !hasChainRestaurants(props.story)) return (null);            

    const open = (e) => {                
        e.preventDefault();
        e.stopPropagation();
        if (!fromMaker /*&& !fromDemo*/ && !playerOnDesktop && !audioAlreadyDisabled && !playAudio){                        
            const ambiantPlayer = document.getElementById(idPrefix + "audio-player");
            if (ambiantPlayer && ambiantPlayer.paused){
                try {
                    ambiantPlayer.play();                
                } catch(error){}
            }
            setPlayAudio(true);            
        }
        pauseVideo();
        openFullscreen();
        setActiveFeature("hours");        
      
        analyticsManager.logCheckHoursTag(props.storyId, playMode, true);
                
        if (appAnalyticsManager)
            appAnalyticsManager.clickedHours();

        if (getStoredPixelConsent() === 'accepted') {
            if (window.ttq){
                window.ttq.track('ViewContent', {                
                    "contents": [
                        {              
                            "content_id": "0",           
                            "content_name": "hours",
                        }
                    ],
                });
            }
            if (window.fbq){                    
                window.fbq('track', 'ViewContent', {"content_name": "hours"});
            }
        }
      };      
    
      if (props.show){                                                                                              
            return <button 
                id="btn-hours-v2"
                name="btn-hours-v2"
                onClick={open}
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: 6 * sizeMultiplier,
                    padding: `${8 * sizeMultiplier}px ${12 * sizeMultiplier}px`,
                    backgroundColor: 'transparent',
                    border: 'none',
                    borderRadius: 8 * sizeMultiplier,
                    color: 'white',
                    fontSize: 14 * sizeMultiplier,
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    fontFamily: 'Roboto, sans-serif'
                }}
                >
                    <img src="/images/ic_access_time.png" alt="" aria-hidden="true" style={{width: 18 * sizeMultiplier, height: 18 * sizeMultiplier}} />
                    <span>{t("Hours")}</span>
            </button>;                            
        }
        else {
            return null;
        }
    }

export default HoursButton;